import React, { useCallback, useContext, useEffect, useState } from 'react';
import RefreshButton from '../Usables/RefreshButton';
import BasicButton, { DateWiseListButton, DeleteButton } from '../Usables/Buttons';
import PageBanner from '../Usables/PageBanner';
import axios from 'axios';
import { basePath, formatDate, isObject, isValidDateTillCurrent, validateFile, validateNumber, validatePhoneNumber } from '../Constants/constant';
import InputField from '../Usables/InputField';
import EditCandidate from '../Usables/EditCandidate';
import Dropdown from '../Usables/Dropdown';
import Loader from '../Usables/Loader';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { AppContext } from '../ContextApi/ContextApi';
import Pagination from '../Usables/Pagination';
import NoRecords from '../Usables/NoRecords';
import { useNavigate, useParams } from 'react-router-dom';

const SourcingList = () => {
    const { index } = useParams();
    const navigate = useNavigate();
    const filterStatusOptions = [
        {value: "Rejected", label: "Rejected"},
        {value: "Confirmation Pending", label: "Confirmation Pending"},
        {value: "Screened", label: "Screened"},
        {value: "Sent To Client", label: "Sent To Client"},
    ];
    const statusOptions = [
        {value: "Rejected", label: "Rejected"},
        {value: "Confirmation Pending", label: "Confirmation Pending"},
        {value: "Screened", label: "Screened"},
    ];
    const relevantOptions = [
        {value: "Yes", label: "Yes"},
        {value: "No", label: "No"},
    ];
 
    const {apiHeaderFile, apiHeaderJSON, user} = useContext(AppContext);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [pagination, setPagination] = useState({page: 1, totalRecords: "", totalPages: "", limit: 10,});
    const [filterData, setFilterData] = useState({});
    const [ischanged, setIschanged] = useState({getListChanged: false, fetchFilterDataChanged: false, statusChanged: false});
    const [viewCandidateEdit, setViewCandidateEdit] = useState(false);
    const [candidateId, setCandidateId] = useState(false);
    const [candidateEdit, setCandidateEdit] = useState(false);
    const [status, setStatus] = useState(false);
    const [formData, setFormData] = useState({candidate_resume: null,});
    const [errors, setErrors] = useState({});

    const getList = useCallback(async()=> {
        try {
            const apiUrl = `${basePath}/getSourcingReportByDate`;
            const res = await axios.get(apiUrl,{
                params:{
                    limit:pagination?.limit, 
                    page:pagination?.page,
                    id:localStorage.getItem("userId"),
                    filter:JSON.stringify(filterData),
                    listView:true
                },
                headers:apiHeaderJSON
            });
            // console.log("getSourcingReportByDate===>", res.data);
            setRows(res.data?.Candidates);
            setPagination({...pagination, totalPages: res?.data?.pages, totalRecords: res?.data?.totalRecords});
            setLoading(false);
            setLoadingFilter(false);
        } catch (error) {
            setLoading(false);
            setLoadingFilter(false);
            console.log(error);
        }
    },[pagination, filterData, apiHeaderJSON]);

    useEffect(()=> {
        setLoading("1");
        getList();
    },[]);
    
    useEffect(()=> {
        if (ischanged?.getListChanged) {
            getList();
            setIschanged({...ischanged, getListChanged: false});
        }
    },[ischanged?.getListChanged]);

    const handleExport = async () => {
        try {
            setLoadingFilter("4");
            const response = await axios.get(`${basePath}/getSourcingReportByDate?download=yes&date=${formatDate(new Date())}&id=${localStorage.getItem("userId")}&filter=${JSON.stringify(filterData)}`, {responseType: 'blob',  headers:apiHeaderJSON});

            // Create a URL for the blob object
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a temporary <a> element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Sourced Candidates${formatDate(new Date())}.xlsx`);
            document.body.appendChild(link);
            link.click();

            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            setLoadingFilter(false);
        } catch (error) {
            console.error('Error exporting jobs:', error);
            setLoadingFilter(false);
        }
    };

    const handleRefresh = () => {
        if (!loading || !loadingFilter) {
            setLoading("1");
            getList();
        }
    }

    const handleChangeFilter = useCallback((event)=> {
        const {name, value} = event?.target;
        // console.log("name, value", name, value);
        setFilterData({ ...filterData, [name]: value, });       
    },[filterData]);

    const handleFilter = useCallback(()=>{ 
        setLoadingFilter("1"); 
        getList();
    },[getList]);
    const handleClear = useCallback(()=> {
        setLoadingFilter("2");
        setFilterData({fromDate: "", toDate: ""});
        setIschanged({...ischanged, getListChanged: true});
    },[ischanged]);

    // handling edit button 
    const handleEdit = (val)=> {
        setCandidateId(val?.id);
        setFormData({
            ...formData,
            company_id: val?.Position?.company_id || "",
            location: val?.Position?.location || "",
            min_ctc: val?.Position?.min_ctc || "",
            max_ctc: val?.Position?.max_ctc || "",
            cv_sourced_from: val?.cv_sourced_from || "",
            relevant: val?.relevant || "",
            sourcing_status: val?.sourcing_status || "",
            candidate: val?.candidate || "",
            candidate_email: val?.candidate_email || "",
            phone_code: val?.phone_code || "",
            candidate_phone: val?.candidate_phone || "",
            phone_alt_code: val?.phone_alt_code || "",
            candidate_alt_phone: val?.candidate_alt_phone || "",
            candidate_location: val?.candidate_location || "",
            candidate_qualification: val?.candidate_qualification || "",
            current_currency_code: val?.current_currency_code || "",
            candidate_current_ctc: val?.candidate_current_ctc || "",
            candidate_ectc_type: val?.candidate_ectc_type || "",
            expected_currency_code: val?.expected_currency_code || "",
            candidate_expected_ctc: val?.candidate_expected_ctc || "",
            candidate_dob: val?.candidate_dob || "",
            candidate_industry: val?.candidate_industry || "",
            candidate_organization: val?.candidate_organization || "",
            candidate_designation: val?.candidate_designation || "",
            candidate_experience: val?.candidate_experience || "",
            candidate_notice_period: val?.candidate_notice_period || "",
            candidate_gender: val?.candidate_gender || "",
            candidate_resume: val?.resume_link || "",
            candidate_remarks: val?.candidate_remarks || "",
            position_questions: val?.CandidateQnAs,
        });
        setStatus(false);
        setViewCandidateEdit(val);
    }

    const handleStatus = async() => {
        try {
            Swal.fire({
            title: 'Are you sure?',
            text: `You want to change status to ${status || ""}!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: `Yes, Source!`,
            cancelButtonText: 'No, Cancel!',
            confirmButtonColor: '#1F1E30', 
            cancelButtonColor: '#F44336',
            allowOutsideClick:false,
            }).then(async(result) => {
                if (!result.isConfirmed) return;
                const data = {
                    candidate_id: candidateId,
                    sourcing_status: status,
                    recruiter_id: localStorage.getItem("userId"),
                }
                // console.log("handleStatus=========>>>>>>", data);
                const options = {
                    headers: { ...apiHeaderJSON },
                }
                const response = await axios.patch(`${basePath}/statuschange`, data, options);
                if (response.status == 200) {
                    setLoading(false);
                    // console.log(response);
                    getList();
                    toast.success("Candidate Status Updated Successfully");
                    setStatus(false);
                }
                else {
                    setLoading(false);
                    toast.error("Unable to post1");
                }
            })
            } catch(e) {
                setLoading(false);
                console.log(e);
                toast.error("There is some network or server issue!! Please try again later.");
            };
    }

    useEffect(()=> {
        if (ischanged?.statusChanged) {
            handleStatus();
            setIschanged({...ischanged, statusChanged: false})
        }
    }, [ischanged?.statusChanged])

    const handleSubmit = (e) => {
        e.preventDefault();
        const errorList = validateForm();
        console.log("errorList 1", errorList);
        if (Object.keys(errorList).length > 0) {
            setErrors(errorList);
            return;
        }
        Swal.fire({
        title: 'Are you sure?',
        text: `${status === "Screened" ? `You want to change status to ${status} and update candidate info!` : "You want update candidate info!"}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Yes, ${status === "Screened" ? "Change" : "Update"}!`,
        cancelButtonText: 'No, Cancel!',
        confirmButtonColor: '#1F1E30', 
        cancelButtonColor: '#F44336',
        allowOutsideClick:false,
        }).then(async(result) => {
            if (!result.isConfirmed) return;
            setLoading("2");
            try {
                const data = {
                    ...formData,
                    candidate_phone: `${formData?.candidate_phone || ""}`,
                    candidate_alt_phone: `${formData?.candidate_alt_phone || ""}`,
                    candidate_question_answers: JSON.stringify(formData?.position_questions),
                    recruiter_id: localStorage.getItem("userId"),
                    candidate_resume: null,
                }
                if(status === "Screened") {
                    data.sourcing_status = "Screened";
                }
                if(isObject(formData?.candidate_resume)){
                    data.candidate_resume = formData?.candidate_resume;
                }
                // console.log("editatspipeline data ========>>>>", data);
                const options = {
                    headers: apiHeaderFile,
                }
                const response = await axios.patch(`${basePath}/editatspipeline/${candidateId}`, data, options);
                if (response.status === 200) {
                    handleClose();
                    getList();
                    setFormData({});
                    setViewCandidateEdit(false);
                    setCandidateId(false);
                    setStatus(false);
                    toast.success(response?.data?.message || "Candidate info Updated Successfully");
                }
                else {
                    toast.error(response?.data?.message || "There is some network or server issue!! Please try again later.");
                }
                setLoading(false);
            } catch (error) {
                console.log(error);
                setLoading(false);
                toast.error(error?.response?.message || "There is some network or server issue!! Please try again later.");
            };
            // if(status === "Screened") handleStatus("e", candidateId);
        });
    }



    const validateForm = ()=>{
        const errors = {};
        if (!formData?.candidate || formData?.candidate.trim() === "") {
            errors.candidate = "Candidate name is required!";
            return errors;
        } else if (formData?.candidate.length < 3) {
            errors.candidate = "Name must be at least 3 characters!";
            return errors;
        } else if (!/^[A-Za-z\s]+$/.test(formData?.candidate)) {
            errors.candidate = "Name can only contain letters!";
            return errors;
        }
        // Email validation
        if (!formData?.candidate_email || formData?.candidate_email.trim() === "") {
            errors.candidate_email = "Email is required!";
            return errors;
        } else if (
            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData?.candidate_email)
        ) {
            errors.candidate_email = "Invalid email address!";
            return errors;
        }

        // mobile number validation
        if (!formData?.phone_code || formData?.phone_code.trim() === "") {
            errors.phone_code = "Required!";
            return errors;
        }
        if (!formData?.candidate_phone || formData?.candidate_phone.trim() === "") {
            errors.candidate_phone = "Mobile number is required!";
        } else if (formData?.phone_code && formData?.candidate_phone) {
            const validateNum = validatePhoneNumber(formData?.phone_code, formData?.candidate_phone);
            if(!validateNum?.isValid && validateNum?.codeError) {
                errors.phone_code = validateNum?.message;
                return errors;
            }
            else if(!validateNum?.isValid && !validateNum?.codeError) {
                errors.candidate_phone = validateNum?.message;
                return errors;
            }
        }
        
        if ((!formData?.phone_alt_code || formData?.phone_alt_code.trim() === "") && formData?.candidate_alt_phone) {
            errors.phone_alt_code = "Required!";
            return errors;
        }
        // if (!formData?.candidate_alt_phone || formData?.candidate_alt_phone.trim() === "") {
        //     errors.candidate_alt_phone = "Mobile number is required!";
        // }
        if (formData?.phone_alt_code && formData?.candidate_alt_phone) {
            const validateNum = validatePhoneNumber(formData?.phone_alt_code, formData?.candidate_alt_phone);
            if(!validateNum?.isValid && validateNum?.codeError) {
                errors.phone_alt_code = validateNum?.message;
                return errors;
            } else if(!validateNum?.isValid && !validateNum?.codeError) {
                errors.candidate_alt_phone = validateNum?.message;
                return errors;
            }
        }

        if (!formData?.candidate_location || formData?.candidate_location.trim() === "") {
            errors.candidate_location = "Candidate location is required!";
            return errors;
        } else if (!/^[A-Za-z\s]+$/.test(formData?.candidate_location)) {
            errors.candidate_location = "Location can only contain letters!";
            return errors;
        }
        if (!formData?.candidate_qualification || formData?.candidate_qualification.trim() === "") {
            errors.candidate_qualification = "Qualification is required!";
            return errors;
        }
        if (!formData?.current_currency_code) {
            errors.current_currency_code = "Required!";
            return errors;
        }
        if (!formData?.candidate_current_ctc || formData?.candidate_current_ctc.trim() === "") {
            errors.candidate_current_ctc = "Current CTC is required!";
            return errors;
        } else if (!validateNumber(formData?.candidate_current_ctc, 100000000)?.success) {
            errors.candidate_current_ctc = validateNumber(formData?.candidate_current_ctc, 500)?.message;
            return errors;
        }
        if (!formData?.candidate_ectc_type) {
            errors.candidate_ectc_type = "Required!";
            return errors;
        }
        if (!formData?.expected_currency_code) {
            errors.expected_currency_code = "Required!";
            return errors;
        }
        if (!formData?.candidate_expected_ctc || formData?.candidate_expected_ctc.trim() === "") {
            errors.candidate_expected_ctc = "Expected CTC is required!";
            return errors;
        } else if (!validateNumber(formData?.candidate_expected_ctc, 100000000)?.success) {
            errors.candidate_expected_ctc = validateNumber(formData?.candidate_expected_ctc, 500)?.message;
            return errors;
        }
        if (!formData?.candidate_industry || formData?.candidate_industry.trim() === "") {
            errors.candidate_industry = "Industry is required!";
            return errors;
        }
        if (!formData?.candidate_experience || formData?.candidate_experience.trim() === "") {
            errors.candidate_experience = "Experience is required!";
            return errors;
        } else if (!validateNumber(formData?.candidate_experience, 50)?.success) {
            errors.candidate_experience = validateNumber(formData?.candidate_experience, 500)?.message;
            return errors;
        }
        if (!formData?.candidate_notice_period) {
            errors.candidate_notice_period = "This field is required!";
            return errors;
        } else if (!validateNumber(formData?.candidate_notice_period, 500)?.success) {
            errors.candidate_notice_period = validateNumber(formData?.candidate_notice_period, 500)?.message;
            return errors;
        }
        if (!formData?.candidate_gender || formData?.candidate_gender.trim() === "") {
            errors.candidate_gender = "This field is required!";
            return errors;
        }
        if (formData?.candidate_dob && !isValidDateTillCurrent(formData?.candidate_dob)) {
            errors.candidate_dob = "DOB should be less or equal to current year!";
            return errors;
        }
        if (formData?.candidate_resume && isObject(formData?.candidate_resume)){
            const valid = validateFile(formData?.candidate_resume, 5, ['application/pdf']);
            if (!valid?.valid) {
                errors.candidate_resume = valid?.message;
                return errors;
            }
        }      
        if( Array.isArray(formData.position_questions) && !validateMandatory()){
            errors.required = "Required!";
            return errors;
        }
    return errors;
}
     // valiadte that is any questions answer is empty or not  
    const validateMandatory = () => {
        let isValid = true;

        const updatedQuestions = formData.position_questions.map(item => {
        if (item.is_mandatory === 1 && (!item.response_text || item.response_text.trim() === "")) {
            isValid = false;
            return { ...item, error_text: "This question is mandatory." };
        }
        return { ...item, error_text: "" };
        });

        setFormData(prev => ({
        ...prev,
        position_questions: updatedQuestions
        }));

        return isValid;
    };

    const handleDelete = (e) => {
        const {value} = e.target;
        Swal.fire({
        title: 'Are you sure?',
        text: `You won't be able to revert this!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Yes, Delete!`,
        cancelButtonText: 'No, Cancel!',
        confirmButtonColor: '#1F1E30', 
        cancelButtonColor: '#F44336',
        allowOutsideClick:false,
        }).then(async(result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Please wait...',
                    html: 'Deleting...',
                    allowOutsideClick: false,
                    didOpen: () => {Swal.showLoading();}
                });
                setLoading("3");
                const options = {
                    url: `${basePath}/deleteCandidate/${value?.id}`,
                    method: "DELETE",
                    headers: {...apiHeaderJSON},
                }
                axios(options)
                .then((response) => {
                    if (response.status === 200) {
                        getList();
                        toast.success(response?.data?.message || "Candidate Deleted Successfully");
                        // console.log("Information Deleted successfully");
                    }
                    else {
                        toast.error("Unable to Delete");
                    }
                    Swal.close();
                    setLoading(false);
                })
                .catch((e) => {
                    Swal.close();
                    setLoading(false);
                    toast.error("There is some network or server issue!! Please try again later.");
                });
            }
        });
    }

    const handleChangeForm = useCallback((event,id)=> {
        const {name, value, option} = event?.target;
        // console.log(name, value, option);
        if(name === "position_id"){
            setFormData({ ...formData, [name]: value, location: option?.location, min_ctc: option?.min_ctc, max_ctc: option?.max_ctc, position_questions: option?.position_questions, positionAnswers: []});
            setErrors({...errors, [name]: ""});

        }
        else if (name === "answer") {
            setFormData(prev => ({
                ...prev,
                position_questions: prev.position_questions.map(item =>
                    item.question_id === id
                    ? { ...item, response_text: value, error_text: "" } // remove error on typing
                    : item
                )}));
        } else if (name === "current_currency_code") {
        setFormData({ ...formData, [name]: value, expected_currency_code: value }); setErrors({...errors, [name]: "", expected_currency_code: ""});
        } else {setFormData({ ...formData, [name]: value, }); setErrors({...errors, [name]: ""});}
    },[formData]);

    const handleViewCandidateEdit = (val)=> {
        setCandidateId(val?.id);
        setFormData({
            ...formData,
            company_id: val?.Position?.company_id || "",
            location: val?.Position?.location || "",
            min_ctc: val?.Position?.min_ctc || "",
            max_ctc: val?.Position?.max_ctc || "",
            cv_sourced_from: val?.cv_sourced_from || "",
            relevant: val?.relevant || "",
            sourcing_status: val?.sourcing_status || "",
            candidate: val?.candidate || "",
            candidate_email: val?.candidate_email || "",
            phone_code: val?.phone_code || "",
            candidate_phone: val?.candidate_phone || "",
            phone_alt_code: val?.phone_alt_code || "",
            candidate_alt_phone: val?.candidate_alt_phone || "",
            candidate_location: val?.candidate_location || "",
            candidate_qualification: val?.candidate_qualification || "",
            current_currency_code: val?.current_currency_code || "",
            candidate_current_ctc: val?.candidate_current_ctc || "",
            candidate_ectc_type: val?.candidate_ectc_type || "",
            expected_currency_code: val?.expected_currency_code || "",
            candidate_expected_ctc: val?.candidate_expected_ctc || "",
            candidate_dob: val?.candidate_dob || "",
            candidate_industry: val?.candidate_industry || "",
            candidate_organization: val?.candidate_organization || "",
            candidate_designation: val?.candidate_designation || "",
            candidate_experience: val?.candidate_experience || "",
            candidate_notice_period: val?.candidate_notice_period || "",
            candidate_gender: val?.candidate_gender || "",
            candidate_resume: val?.resume_link || "",
            candidate_remarks: val?.candidate_remarks || "",
            position_questions: val?.CandidateQnAs,
        });
        setViewCandidateEdit(val);
    }

    const handleCancelEdit = () => {
        setFormData({
            ...formData,
            company_id: viewCandidateEdit?.Position?.company_id || "",
            location: viewCandidateEdit?.Position?.location || "",
            min_ctc: viewCandidateEdit?.Position?.min_ctc || "",
            max_ctc: viewCandidateEdit?.Position?.max_ctc || "",
            cv_sourced_from: viewCandidateEdit?.cv_sourced_from || "",
            relevant: viewCandidateEdit?.relevant || "",
            sourcing_status: viewCandidateEdit?.sourcing_status || "",
            candidate: viewCandidateEdit?.candidate || "",
            candidate_email: viewCandidateEdit?.candidate_email || "",
            phone_code: viewCandidateEdit?.phone_code || "",
            candidate_phone: viewCandidateEdit?.candidate_phone || "",
            phone_alt_code: viewCandidateEdit?.phone_alt_code || "",
            candidate_alt_phone: viewCandidateEdit?.candidate_alt_phone || "",
            candidate_location: viewCandidateEdit?.candidate_location || "",
            candidate_qualification: viewCandidateEdit?.candidate_qualification || "",
            current_currency_code: viewCandidateEdit?.current_currency_code || "",
            candidate_current_ctc: viewCandidateEdit?.candidate_current_ctc || "",
            candidate_ectc_type: viewCandidateEdit?.candidate_ectc_type || "",
            expected_currency_code: viewCandidateEdit?.expected_currency_code || "",
            candidate_expected_ctc: viewCandidateEdit?.candidate_expected_ctc || "",
            candidate_dob: viewCandidateEdit?.candidate_dob || "",
            candidate_industry: viewCandidateEdit?.candidate_industry || "",
            candidate_organization: viewCandidateEdit?.candidate_organization || "",
            candidate_designation: viewCandidateEdit?.candidate_designation || "",
            candidate_experience: viewCandidateEdit?.candidate_experience || "",
            candidate_notice_period: viewCandidateEdit?.candidate_notice_period || "",
            candidate_gender: viewCandidateEdit?.candidate_gender || "",
            candidate_resume: viewCandidateEdit?.candidate_resume || "",
            candidate_remarks: viewCandidateEdit?.candidate_remarks || "",
            position_questions: viewCandidateEdit?.CandidateQnAs,
        });
        setCandidateEdit(false);
    }
    const handleEditOn = ()=> {
        setCandidateEdit(true);
    }
    const handleClose = ()=> {
        console.log("onClose out");
        setFormData({});
        setErrors({});
        // setFilterData({candidate: "", company: "", position: "", location: "", relevant: "", status: ""});
        setViewCandidateEdit(false);
        setCandidateEdit(false);
        setStatus(false);
    }
    const handleChangeStatus = (e,idx,val) => {
        if (e.target.value === "Screened") {
            handleViewCandidateEdit(val);
            setCandidateEdit(true);
            setCandidateId(val?.id);
            setStatus(e.target.value);
        } else if (e.target.value !== val?.sourcing_status) {
            setIschanged({...ischanged, statusChanged: true});
            setCandidateId(val?.id);
            setStatus(e.target.value);
        }
    }

    const handleLimit = (e)=> {
        setPagination({...pagination, limit: e.target.value});
        setIschanged({...ischanged, getListChanged: true});
    }
    const handlePrev = (e)=> {
        if (pagination?.page > 1) {
            setPagination({...pagination, page: pagination?.page - 1});
            setIschanged({...ischanged, getListChanged: true});
        }
    }
    const handleNext = (e)=> {
        
        if (pagination?.totalPages > pagination?.page) {
            setPagination({...pagination, page: pagination?.page + 1});
            setIschanged({...ischanged, getListChanged: true});
        }
    }

    const handleCheckStatus = (value)=> {
        const statusList = [
        {name: "Rejected", className: "rounded-lg text-red-500 redBox"},
        // {name: "Confirmation Pending", className: "rounded-lg text-amber-500 bg-amber-100"},
        {name: "Screened", className: "rounded-lg text-blue-500 bg-blue-100"},
        {name: "Sent To Client", className: "rounded-lg text-green-500 bg-green-100"},
        ];
        return statusList.find(status => status?.name === value) || false;
    };

    return (
        <section className='  w-full'>
            {/* RefreshButton => used for refresh table data */}
            <RefreshButton onClick={handleRefresh} position='fixed' />
            <DateWiseListButton onClick={()=> navigate(-1)} />
            {/* PageBanner => used to show page banner info */}
            <PageBanner pageName='Daily Sourcing List' pageTitle='Ready to start your day' src='/img/master.png' alt="screened candidate" />
            {/* Edit candiate info */}
            {viewCandidateEdit ?
                <div className=' w-full h-screen fixed left-0 top-0 z-40 flex items-center justify-center blurBack'>
                    <div className=' bg-white overflow-auto mx-10 mb-5 p-10 rounded-3xl candidateInfoBox'>
                        <EditCandidate
                        onChange={handleChangeForm}
                        onCancel={handleCancelEdit}
                        onClose={handleClose}
                        onSubmit={handleSubmit}
                        OnlyView={!user[index]?.edit_access}
                        onEdit={handleEditOn}
                        data={formData}
                        loading={loading === "2"}
                        errors={errors}
                        disabled={!candidateEdit}
                        />
                    </div>
                </div> : null}
            <div className='h-full w-full  rounded-2xl overflow-y-scroll noScrollbar pt-4 px-0.5'>
                {/* filter */}
                <div className=' grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 items-center gap-3 grayBlurShadow bg-white p-3 mb-5 rounded-xl'>
                    <InputField  id="candidate" name="candidate" type="text" label="Candidate:"
                    placeholder="Enter Candidate"
                    disabled={loading === '1'}
                    value={filterData?.candidate}
                    onChange={handleChangeFilter}
                    />
                    <InputField  id="company" name="company" type="text" label="Company:"
                    placeholder="Enter Company"
                    disabled={loading === '1'}
                    value={filterData?.company}
                    onChange={handleChangeFilter}
                    />
                    <InputField  id="position" name="position" type="text" label="Position:"
                    placeholder="Enter Position"
                    disabled={loading === '1'}
                    value={filterData?.position}
                    onChange={handleChangeFilter}
                    />
                    <InputField  id="location" name="location" type="text" label="Location:"
                    placeholder="Enter Location"
                    disabled={loading === '1'}
                    value={filterData?.location}
                    onChange={handleChangeFilter}
                    />
                    <Dropdown id="relevant" name="relevant" label="Relevant:"
                    onChange={handleChangeFilter}
                    className=" rounded border border-gray-300 w-full text-[0.8rem]"
                    placeholder={`Select`}
                    value={filterData?.relevant}
                    options={relevantOptions}
                    />
                    <Dropdown id="status" name="status" label="Sourcing Status:"
                    onChange={handleChangeFilter}
                    className=" rounded border border-gray-300 w-full text-[0.8rem]"
                    placeholder={`Select Status`}
                    value={filterData?.status}
                    options={filterStatusOptions}
                    />
                    <div className="flex gap-3 col-span-1">
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Apply Filter</label>
                            <BasicButton onClick={handleFilter} buttonName='Apply Filter' className='darkPurple text-nowrap' shadow={true}
                            disabled={loading || loadingFilter || (!filterData?.candidate && !filterData?.company && !filterData?.position && !filterData?.location && !filterData?.relevant && !filterData?.status)} 
                            loading={loadingFilter === "1"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
                        </div>
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Clear Filter</label>
                            <BasicButton onClick={handleClear} buttonName='Clear Filter' className="bg-red-600 text-nowrap" shadow={true}
                            disabled={loading || loadingFilter || (!filterData?.candidate && !filterData?.company && !filterData?.position && !filterData?.location && !filterData?.relevant && !filterData?.status)} 
                            loading={loadingFilter === "2"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-red-900" />
                        </div>
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Excel Export</label>
                            <BasicButton onClick={handleExport} buttonName='Excel' className="bg-green-800 text-nowrap" shadow={true}
                            disabled={loading || loadingFilter || rows?.length === 0} 
                            loading={loadingFilter === "4"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-green-950" />
                        </div>
                    </div>
                </div>
                {
                    loading === "1" ?
                    <Loader/> :
                    Array.isArray(rows) && rows?.length >= 1 ?
                    <div className='tableWrapper'>
                        <div className='tableBody'>
                            <table className='w-full table-fixed border-collapse'>
                                <thead className='tableHead'>
                                    <tr className=' bg-gray-200'>
                                        <th className='whitespace-nowrap text-center'>Sourcing Date</th>
                                        <th className='w-[16%]'>Candidate</th>
                                        <th className='whitespace-nowrap w-[16%]'>Position</th>
                                        <th className='whitespace-nowrap'>Position CTC</th>
                                        <th className='whitespace-nowrap'>CV Sourced From</th>
                                        <th className='w-[10%]'>Relevant</th>
                                        <th className='whitespace-nowrap text-center  w-[15%]'>Status</th>
                                        {user[index]?.delete_access && <th className='whitespace-nowrap text-center  w-[7%]'>Action</th>}
                                    </tr>
                                </thead>
                                <tbody className='tableBody '>
                                    {
                                        Array.isArray(rows) && rows?.map((val, idx) => {
                                            return (
                                                <tr key={val?.id} id={val?.id} className=' backWhite font-semibold text-sm text-left'>
                                                    <td className=' whitespace-nowrap text-left'>
                                                        <span className='line-clamp-1 text-ellipsis'>{val?.sourcing_date ? formatDate(val?.sourcing_date) : "--"}</span>
                                                        {localStorage.getItem("role") === "Recruiter" || localStorage.getItem("role") === "Team Lead" ? null : 
                                                        (<span className={`line-clamp-1 text-ellipsis ${val?.sourcing_status === 'Confirmation Pending' ? `text-yellow-600`: val?.sourcing_status === 'Rejected' ? `text-red-700` : `text-green-600`}`}
                                                        >{val?.User?.name}</span>)}
                                                    </td>
                                                    <td className=' '>
                                                        <span className={`line-clamp-1 text-ellipsis text-blue-900 ${val?.candidate && (user[index]?.view_access || user[index]?.edit_access) && "hover:text-blue-700 hover:underline transition-all duration-150 ease-in-out cursor-pointer"}`} onClick={()=> { if (val?.candidate && (user[index]?.view_access || user[index]?.edit_access)) handleEdit(val)}}>{val?.candidate || "--"}</span>
                                                        <span className='text-sm line-clamp-1 text-ellipsis text-gray-400'>{val?.candidate_email ? val?.candidate_email : "NA"}</span>
                                                    </td>
                                                    <td className=' '>
                                                        <span className='line-clamp-1 text-ellipsis' >{val?.Position?.position}</span>
                                                        <span className='text-sm line-clamp-1 text-ellipsis text-gray-400'>{val?.Position?.Company.company_name}</span>
                                                    </td>
                                                    <td>
                                                        <div className=' flex flex-col'>
                                                            <span><span className=' text-green-500'>{val?.current_currency_code}</span> {val?.Position?.min_ctc?.padStart(2,0) || "00"} LPA</span> 
                                                            <span><span className=' text-green-500'>{val?.current_currency_code}</span> {val?.Position?.max_ctc?.padStart(2,0) || "00"} LPA</span>
                                                        </div>
                                                    </td>
                                                    <td>{val?.cv_sourced_from}</td>
                                                    <td className='whitespace-nowrap text-center'>
                                                        <div className={` whitespace-nowrap py-2 px-1 border border-gray-300  ${val?.relevant === "Yes" ? " text-green-500 greenBox" : "text-red-600 redBox"}`} >
                                                            {val?.relevant}</div>
                                                    </td>
                                                    <td className='whitespace-nowrap text-center'>
                                                        {handleCheckStatus(val?.sourcing_status) ? 
                                                        <h3 className={`line-clamp-1 text-ellipsis w-full text-center text-nowrap outline-none border border-gray-300 py-2.5 px-1 ${handleCheckStatus(val?.sourcing_status)?.className}`}>
                                                            {handleCheckStatus(val?.sourcing_status)?.name}
                                                        </h3> :
                                                            <Dropdown id="company_id" name="company_id"
                                                            onChange={(e)=> handleChangeStatus(e,idx,val)}
                                                            className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                                            placeholder={`Select`}
                                                            value={val?.sourcing_status}
                                                            options={statusOptions}
                                                            disabled={!user[index]?.edit_access}
                                                            />
                                                        }
                                                    </td>
                                                    {user[index]?.delete_access && <td className=' flex justify-center items-center'>
                                                        <DeleteButton data={val} onClick={handleDelete} tooltipName="Delete" disabled={val?.sourcing_status === "Sent To Client"} />
                                                    </td>}

                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table >
                        </div>
                        <Pagination onLimitChange={handleLimit} onPrevChange={handlePrev} onNextChange={handleNext}
                        limit={pagination?.pagelimit} totalRecords={pagination?.totalRecords} allPages={pagination?.totalPages} page={pagination?.page}
                        disabledPrev={pagination?.page === 1} disabledNext={pagination?.page === pagination?.totalPages}
                        />
                    </div> :
                    <NoRecords/>
                }
            </div>
        </section>
    );
}

export default SourcingList;
